<div class="flex-column">
  <div style="display: flex; gap: 8px" *ngIf="showButtons" style="margin-bottom: 8px" class="flex-row flex-end ag-tree-container">
    <img [src]="iconService.Icon.down_arrow_1_5" width="16" height="16" (click)="expandAll()" />
    <img [src]="iconService.Icon.up_arrow_1_5" width="16" height="16" (click)="collapseAll()" />
  </div>
  <ng-content></ng-content>
</div>
